<template>
    <ItemMenuWrapper :label="label" v-slot="{ inputId }">
        <div class="flex align-items-center gap-2">
            <InputText :id="inputId" type="number" v-model="dimensaoValor" @update:modelValue="handleUpdate" style="width: 70%" />
            <Dropdown
                v-model="unidadeSelecionada"
                :options="unidades"
                optionLabel="label"
                optionValue="value"
                @change="handleUpdate"
                style="width: 30%; margin-left: 0.5rem"
            />
        </div>
    </ItemMenuWrapper>
</template>

<script setup>
import ItemMenuWrapper from './ItemMenuWrapper.vue';
import { defineProps, defineEmits, ref, watch, computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: String,
        default: '100%',
    },
    label: {
        type: String,
        required: true,
    },
    unidade: {
        type: String,
        default: 'px',
    },
});

const emit = defineEmits(['update:modelValue']);

const unidades = [
    { label: 'px', value: 'px' },
    { label: '%', value: '%' },
];

const unidadeSelecionada = ref(props.unidade);
const dimensaoValor = ref('100');

watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal) {
            const valor = newVal.replace(/[^0-9.]/g, '');
            const unidade = newVal.replace(/[0-9.]/g, '');
            dimensaoValor.value = valor;
            unidadeSelecionada.value = unidade || 'px';
        }
    },
    { immediate: true }
);

const valorCompleto = computed(() => `${dimensaoValor.value}${unidadeSelecionada.value}`);

const handleUpdate = () => {
    emit('update:modelValue', valorCompleto.value);
};
</script>
